import { isWeb } from '../utilities/platform';
import { CLINIC_STORAGE_KEYS } from '../constants/buyer-portal';
import { ERR_UNAUTHORIZED } from './errors';

export const readUserIdFromToken = (): string => {
  if (!isWeb) throw ERR_UNAUTHORIZED();
  const token = localStorage.getItem(CLINIC_STORAGE_KEYS.TOKEN);
  if (!token) throw ERR_UNAUTHORIZED();
  const parts = token.split('.');
  if (parts.length < 2 || !parts[1]) throw ERR_UNAUTHORIZED();
  return parts[1];
};

export const hasToken = (): boolean => {
  if (!isWeb) return false;
  return !!localStorage.getItem(CLINIC_STORAGE_KEYS.TOKEN);
};
